import React from 'react'
import { Routes, Route, useNavigate, useParams } from 'react-router-dom'
import { useNavigate, useParams } from 'react-router-dom'

import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Paper from '@mui/material/Paper'


import { useQuery, useCommand } from '~/client/hooks/cqrpc'

import Link from '~/client/components/Link'
import DocumentTypeCreateForm from '~/client/components/DocumentTypeCreateForm'

export default function Page(props) {
  const navigate = useNavigate()
  const create = useCommand('documentTypes.create', {
    onSuccess(documentType){
      navigate(`/data/types/${documentType.id}`)
    }
  })
  const [value, onChange] = React.useState({
    name: '',
    description: '',
    schema: '',
  })
  console.log('NEW PAGE VALUE', value)
  return <Container>
    <Paper sx={{p: 2, my: 1}}>
      <Typography variant="h6">New Document Type</Typography>
      <DocumentTypeCreateForm {...{
        value,
        onChange,
        onSubmit(){
          const {name, description, schema} = value
          create.call({
            name,
            description,
            schema,
          })
        },
        submitting: create.pending,
        error: create.error,
      }}/>
    </Paper>
  </Container>
}
